module.exports = __webpack_public_path__ + "static/media/diamond.4252759f.svg";